import { Event, EventCallbackFunction, IEventEmitter, IdEventCallbackFunction } from "./types";

export class SequentialEventEmitter<T extends string = Event> implements IEventEmitter {
  private registeredEvents: Record<Event, IdEventCallbackFunction[]> = {};

  public on(event: T, func: EventCallbackFunction, id?: string) {
    if (!this.registeredEvents[event]) {
      this.registeredEvents[event] = [];
    }

    this.registeredEvents[event].push({ id, func });
  }

  public async emit(event: T, ...args: any[]) {
    if (this.registeredEvents[event]) {
      for (const func of this.registeredEvents[event]) {
        await func.func(...args);
      }

      return true;
    }

    return false;
  }

  public getListeners(event: T): EventCallbackFunction[] {
    return this.registeredEvents[event]?.map(f => f.func) || [];
  }

  public removeListener(event: T, listener: EventCallbackFunction): IEventEmitter {
    const funcIndex = this.registeredEvents[event]?.findIndex(f => f.func === listener) ?? -1;
    if (funcIndex != -1) {
      this.registeredEvents[event].splice(funcIndex, 1);
    }

    return this;
  }

  public removeListenerById(event: T, id: string): IEventEmitter {
    const funcIndex = this.registeredEvents[event]?.findIndex(f => f.id === id);

    if (funcIndex !== undefined && funcIndex != -1) {
      this.registeredEvents[event].splice(funcIndex, 1);
    }

    return this;
  }


}